import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {ref, watch} from "vue";
import SogForm from "@/shared/ui/SogForm.vue";
import SogFormField from "@/shared/ui/SogFormField.vue";
import SogNumericTextBox from "@/shared/ui/SogNumericTextBox.vue";
import SogTextBox from "@/shared/ui/SogTextBox.vue";
import {computed} from "vue";
import {fillNumberWithZeros} from "@/shared/utils/NumberUtils";

interface Props {
  /** Vorbelegung der Stückzahl, z. B. der Fehlbestand einer Filiale. */
  count?: number
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ExportBlankFormComponent',
  props: {
    count: { default: undefined }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props

const _prefix = ref("AV")
const _startNumber = ref(1)
const _digitCount = ref(7)
const _count = ref(1)

// Nur die Anzahl wird vorbelegt - Prefix, Startnummer und Stellenzahl gibt der
// Nutzer bewusst selbst ein.
watch(() => props.count, (t_value) => {
  if (t_value && t_value > 0) {
    _count.value = t_value
  }
}, {immediate: true})

const _sample = computed(() => {
  const t_start = fillNumberWithZeros(_startNumber.value, _digitCount.value)
  const t_end = fillNumberWithZeros((_startNumber.value + _count.value - 1), _digitCount.value)
  return _prefix.value + t_start + " - " + _prefix.value + t_end
})

function getResults(): { prefix: string, startNumber: number, digitCount: number, count: number } {
  return {prefix: _prefix.value, startNumber: _startNumber.value, digitCount: _digitCount.value, count: _count.value};
}

__expose({
  getResults
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogForm, null, {
    default: _withCtx(() => [
      _createVNode(SogFormField, { width: "200px" }, {
        default: _withCtx(() => [
          _createVNode(SogNumericTextBox, {
            ref: "_eCount",
            modelValue: _count.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_count).value = $event)),
            placeholder: "Anzahl",
            format: "n",
            width: "150px",
            min: 1
          }, null, 8, ["modelValue"]),
          _createVNode(SogTextBox, {
            ref: "_ePrefix",
            modelValue: _prefix.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_prefix).value = $event)),
            placeholder: "Prefix",
            width: "150px"
          }, null, 8, ["modelValue"]),
          _createVNode(SogNumericTextBox, {
            ref: "_eStartNumber",
            modelValue: _startNumber.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_startNumber).value = $event)),
            placeholder: "Startnummer",
            format: "n",
            width: "150px",
            min: 1
          }, null, 8, ["modelValue"]),
          _createVNode(SogNumericTextBox, {
            ref: "_eDigitCount",
            modelValue: _digitCount.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_digitCount).value = $event)),
            placeholder: "Anzahl Ziffern",
            format: "n",
            width: "150px",
            min: 1
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(SogFormField, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_sample.value), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})